var exports = {
  "zr": "ScreenSharePickerModal.module__root___WnhYMX",
  "XV": "ScreenSharePickerModal.module__topBar___WnhYMX",
  "vR": "ScreenSharePickerModal.module__tabs___WnhYMX",
  "Gn": "ScreenSharePickerModal.module__tabLabel___WnhYMX",
  "Ll": "ScreenSharePickerModal.module__tabIcon___WnhYMX",
  "Qs": "ScreenSharePickerModal.module__content___WnhYMX",
  "Vg": "ScreenSharePickerModal.module__grid___WnhYMX",
  "Nr": "ScreenSharePickerModal.module__card___WnhYMX",
  "e5": "ScreenSharePickerModal.module__cardPending___WnhYMX",
  "VH": "ScreenSharePickerModal.module__preview___WnhYMX",
  "np": "ScreenSharePickerModal.module__previewDevice___WnhYMX",
  "Gh": "ScreenSharePickerModal.module__cardSelected___WnhYMX",
  "oz": "ScreenSharePickerModal.module__previewImage___WnhYMX",
  "yQ": "ScreenSharePickerModal.module__devicePreviewVideo___WnhYMX",
  "A3": "ScreenSharePickerModal.module__previewPlaceholder___WnhYMX",
  "Cd": "ScreenSharePickerModal.module__devicePreviewPlaceholder___WnhYMX",
  "mP": "ScreenSharePickerModal.module__previewIcon___WnhYMX",
  "rP": "ScreenSharePickerModal.module__previewOverlay___WnhYMX",
  "H5": "ScreenSharePickerModal.module__previewAction___WnhYMX",
  "zI": "ScreenSharePickerModal.module__cardBody___WnhYMX",
  "Dm": "ScreenSharePickerModal.module__cardSourceIcon___WnhYMX",
  "gL": "ScreenSharePickerModal.module__cardSourceIconImage___WnhYMX",
  "JJ": "ScreenSharePickerModal.module__cardTitle___WnhYMX",
  "wk": "ScreenSharePickerModal.module__state___WnhYMX",
  "Ml": "ScreenSharePickerModal.module__loadingState___WnhYMX",
  "hZ": "ScreenSharePickerModal.module__stateIcon___WnhYMX",
  "CY": "ScreenSharePickerModal.module__stateHeading___WnhYMX",
  "_A": "ScreenSharePickerModal.module__stateTitle___WnhYMX",
  "tM": "ScreenSharePickerModal.module__stateActions___WnhYMX",
  "xj": "ScreenSharePickerModal.module__osNotice___WnhYMX",
  "Hr": "ScreenSharePickerModal.module__downloadCta___WnhYMX",
  "wN": "ScreenSharePickerModal.module__downloadCopy___WnhYMX",
  "z5": "ScreenSharePickerModal.module__downloadTitle___WnhYMX",
  "h": "ScreenSharePickerModal.module__downloadDescription___WnhYMX",
  "qm": "ScreenSharePickerModal.module__downloadActions___WnhYMX",
  "aQ": "ScreenSharePickerModal.module__platformIcons___WnhYMX",
  "tV": "ScreenSharePickerModal.module__platformIcon___WnhYMX",
  "qr": "ScreenSharePickerModal.module__footer___WnhYMX",
  "wu": "ScreenSharePickerModal.module__footerStart___WnhYMX",
  "vM": "ScreenSharePickerModal.module__streamSummary___WnhYMX",
  "ru": "ScreenSharePickerModal.module__streamSummaryTitle___WnhYMX",
  "$o": "ScreenSharePickerModal.module__streamSummaryDetails___WnhYMX",
  "sw": "ScreenSharePickerModal.module__streamSummaryDetail___WnhYMX",
  "Xd": "ScreenSharePickerModal.module__streamButton___WnhYMX",
  "ZF": "ScreenSharePickerModal.module__previewNotice___WnhYMX",
  "cP": "ScreenSharePickerModal.module__previewNoticeText___WnhYMX",
  "vw": "ScreenSharePickerModal.module__previewNoticeInfoButton___WnhYMX",
  "Ip": "ScreenSharePickerModal.module__previewInfoContent___WnhYMX",
  "Jh": "ScreenSharePickerModal.module__previewInfoParagraph___WnhYMX",
  "NZ": "ScreenSharePickerModal.module__previewInfoSwitch___WnhYMX",
};

module.exports = exports;
